import { render, staticRenderFns } from "./EditChargebackType.vue?vue&type=template&id=4f28cb0b&"
import script from "./EditChargebackType.vue?vue&type=script&lang=js&"
export * from "./EditChargebackType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports